import { Component, Input, EventEmitter, Output } from '@angular/core'

import { Address, AddressType, UIStrings } from '../../models/models'

import { NavController, ActionSheetController, AlertController, ToastController } from 'ionic-angular'
import { AddressEditPage } from '../../pages/address-edit/address-edit'
import { AddressProvider } from '../../providers/address/address'
import { AuthProvider } from '../../providers/auth/auth'

@Component({
	selector: 'address-item',
	templateUrl: 'address-item.html',
	//directives : [AUTOCOMPLETE_DIRECTIVES],
	inputs: [
		'address',
		'isTypeVisible',
		'isPriorityVisible',
		'isEditable',//Link a pagina edit
		'title'
	],
	outputs: [
	]
})
export class AddressItemComponent {
	public address: Address
	public title: string


	@Output() refresh: EventEmitter<Address> = new EventEmitter<Address>();

	private _isEditable: boolean = null;
	private _isDeletable: boolean = null;

	//@Input() isShowable:boolean=true;
	@Input() set isEditable(isEditable: boolean) {
		this._isEditable = isEditable
	}
	get isEditable(): boolean {
		if(this._isEditable === false) return false//Blocco esplicito
		//Verifica dei permessi
		return this.auth.canAddressEdit(this.address)
	}

	@Input() set isDeletable(isDeletable: boolean) {
		this._isDeletable = isDeletable
	}
	get isDeletable(): boolean {
		if(this._isDeletable === false) return false//Blocco esplicito
		//Verifica dei permessi
		return this.auth.canAddressDelete(this.address)
	}


	@Input() isPriorityVisible: boolean = false;
	@Input() isTypeVisible: boolean = false;

	get label(): string {
		if(this.title) return this.title
		if(!this.address) return 'INDIRIZZO MANCANTE'
		if(this.address.name) return this.address.name
		switch(this.address.type) {
			case AddressType.CONTACT:
				return 'Contatto'
			case AddressType.LOCATION:
				return 'Indirizzo'
			default:
				console.warn('Tipo indirizzo sconosciuto', this.address)
				return 'TIPO INDIRIZZO DI TIPO SCONOSCIUTO'
		}
	}

	constructor(
		private auth: AuthProvider,
		public actionSheetCtrl: ActionSheetController,
		private alertCtrl: AlertController,
		public navCtrl: NavController,
		private addresses: AddressProvider,
		private toastCtrl: ToastController,
	) {
	}


	goToAddressEdit() {
		if(!this.address) {
			console.error("Indirizzo non specificato per address-item")
			return
		}
		this.navCtrl.push(AddressEditPage, { address: this.address })
	}

	public openURL(url: string, event) {
		event.stopPropagation()
		window.open(url, '_system')
	}

	showDestroyAddressConfirm() {
		if(!this.address) {
			console.error("Indirizzo non specificato per address-item")
			return
		}
		let self = this
		let address = this.address

		let confirm = this.alertCtrl.create({
			title: "Eliminare l'indirizzo dal server?",
			message: "Vuoi davvero eliminare l'indirizzo " + address.name + " " + address.formatted + "?",
			buttons: [
				{
					text: UIStrings.DIALOG_CANCEL,
					role: 'cancel'
				}, {
					text: UIStrings.DELETE,
					handler: () => {
						self.addresses.destroy(address).then((success: boolean) => {
							if(success) {
								let toast = self.toastCtrl.create({
									message: 'Indirizzo eliminato',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								})
								toast.present()
								self.refresh.emit(address)
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore eliminando l'indirizzo",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								})
								toast.present()
							}
							self.refresh.emit(address)
						}).catch(error => {
							console.error("Errore eliminando l'indirizzo", error)
							let toast = self.toastCtrl.create({
								message: "Errore eliminando l'indirizzo",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							})
							toast.present()
							self.refresh.emit(address)
						})
					}
				}
			]
		})
		confirm.present()
	}
	public showMenu() {
		if(!(this.isDeletable || this.isEditable)) return//non può fare azioni

		let self = this
		let buttons = []

		if(this.isEditable) {
			buttons.push({
				text: UIStrings.EDIT,
				role: 'destructive',
				icon: 'create',
				handler: () => {
					self.goToAddressEdit()
				}
			})
		}
		if(this.isDeletable) {
			buttons.push({
				text: UIStrings.DELETE,
				role: 'destructive',
				icon: 'trash',
				handler: () => {
					self.showDestroyAddressConfirm()
				}
			})
		}
		buttons.push({
			text: UIStrings.MENU_CLOSE,
			role: 'cancel',
			icon: 'undo',
			handler: () => {}
		})

		let title: string
		switch(this.address.type) {
			case AddressType.CONTACT:
				title = 'Contatto'
			case AddressType.LOCATION:
				title = 'Indirizzo'
				break
			default:
				console.warn('Tipo indirizzo sconosciuto', this.address)
				title = 'TIPO INDIRIZZO SCONOSCIUTO'
				break
		}
		let subtitle = this.address.formatted
		let options = {
			title: title,
			subTitle: subtitle,
			buttons: buttons
		}

		let actionSheet = this.actionSheetCtrl.create(options)
		actionSheet.present()
	}
}



// WEBPACK FOOTER //
// ./src/components/address-item/address-item.ts